// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"echarts_wrapper-module___loadingWrapper___d2de9391"};